(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["how-immy-works-v2"]) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function() {
    const swiper = new Swiper('.hiw-swiper-container', {
      wrapperClass: 'hiw-slider-wrapper',
      slideClass: 'hiw-slide',
      allowTouchMove: true,
      spaceBetween: 10,
      slidesPerView: 1,
      lazy: true,
      autoplay: {
        delay: 5000, // Slide display time (5 seconds)
        disableOnInteraction: false
      },
      pagination: {
        el: '.tinyflow-slider__pagination',
        clickable: true,
        renderBullet: function(index, className) {
          return `<button type="button" aria-label="pagination ${
            index + 1
          }" class="tinyflow-slider__pagination__btn_hiw ${className}" style="--_progress: 0%;"></button>`;
        }
      },
      on: {
        init: function(swiper) {

// Initial progress bar animation
          setTimeout(() => {
            startProgressBarAnimation(swiper);
          }, 10); // Slight delay to ensure swiper is fully initialized
        },
        slideChange: function(swiper) {

// Restart progress bar animation on slide change
          resetProgressBarAnimation(swiper);
          startProgressBarAnimation(swiper);
        }
      }
    });

    function startProgressBarAnimation(swiper) {
      const activeBullet = swiper.pagination.bullets[swiper.realIndex];
      activeBullet.style.setProperty('--_progress', '100%');
      activeBullet.classList.add('animating');
    }

    function resetProgressBarAnimation(swiper) {
      swiper.pagination.bullets.forEach(function(bullet, index) {
        bullet.style.setProperty('--_progress', '0%');
        bullet.classList.remove('animating');
      });
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hp-pdp-section"] && !window.DesignMode) return;
  try {
    
    document.addEventListener('DOMContentLoaded', function () {
    const container = document.querySelector('.pg-swiper-container');
    const paginationEl = container.querySelector('.custom-product-pagination');

    const swiper = new Swiper(container, {
      wrapperClass: 'pg-swiper-wrapper',
      slideClass:   'pg-swiper-slide',
      allowTouchMove: true,
      spaceBetween:   10,
      slidesPerView:  1,
      lazy:           true,
      autoplay: {
        delay: 5000,
        disableOnInteraction: false,
      },
      keyboard: {
        enabled: true,
        onlyInViewport: true,
      },
      pagination: {
        el:        paginationEl,
        type:      'custom',
        clickable: true,
        renderCustom: function (s, current, total) {
          const prev = current > 1 ? current - 1 : 1;
          const next = current < total ? current + 1 : total;
          let activeIdx;
          if (current === 1) activeIdx = 0;
          else if (current === total) activeIdx = 2;
          else activeIdx = 1;
          const pages = [prev, current, next];
          return pages.map((num, idx) => `
            <button
              type="button"
              aria-label="Go to slide ${num}"
              class="custom-product-pagination__btn${idx === activeIdx ? ' active' : ''}"
              data-index="${num}"
              style="--_progress: 0%;"
            ></button>`).join('');
        }
      },
      on: {
        init: function (s) {
          s.pagination.render(); s.pagination.update();
          paginationEl.addEventListener('click', e => {
            const btn = e.target.closest('.custom-product-pagination__btn');
            if (!btn) return;
            const idx = Number(btn.dataset.index) - 1;
            if (!isNaN(idx)) s.slideTo(idx);
          });
          setTimeout(() => startProgress(s), 10);
        },
        slideChange: function (s) {
          s.pagination.render(); s.pagination.update();
          resetProgress(); startProgress(s);
        },
        autoplay: function (s) {
          s.pagination.render(); s.pagination.update();
          resetProgress(); startProgress(s);
        }
      }
    });

    function resetProgress() {
      const btns = paginationEl.querySelectorAll('.custom-product-pagination__btn');
      btns.forEach(b => {
        b.style.setProperty('--_progress', '0%');
        b.classList.remove('animating');
      });
    }

    function startProgress(sw) {
      const bullet = paginationEl.querySelector('.custom-product-pagination__btn.active');
      if (!bullet) return;
      bullet.classList.remove('animating');
      void bullet.offsetWidth;
      bullet.style.setProperty('--_progress', '100%');
      bullet.classList.add('animating');
    }
  });

//WHY SUBSCRIBE POPUP
  document.getElementById('why-sub').addEventListener('click', function(event) {
    event.preventDefault(); // Prevent the default link behavior
    document.getElementById('sub-popup').classList.add('active'); // Show the popup
    document.getElementById('popup-overlay').classList.add('active'); // Show the overlay
  });

  document.getElementById('popup-overlay').addEventListener('click', function() {
    document.getElementById('sub-popup').classList.remove('active'); // Hide the popup
    document.getElementById('popup-overlay').classList.remove('active'); // Hide the overlay
  });

  document.getElementById('close-popup').addEventListener('click', function() {
    document.getElementById('sub-popup').classList.remove('active'); // Hide the popup
    document.getElementById('popup-overlay').classList.remove('active'); // Hide the overlay
  });




document.addEventListener('DOMContentLoaded', function() {
  // 1) Grab your Shopify product form
  const productForm = document.querySelector('form.shopify-product-form[is="product-form"]');
  if (!productForm) return;

  // 2) Find the hidden variant-id input (Shopify keeps this updated)
  const variantInput = productForm.querySelector('input[name="id"]');
  if (!variantInput) return;

  // 3) Sync function: inject/remove the selling_plan field
  function syncSellingPlan() {
    const vid        = variantInput.value;
    const SUB_VID    = '49098774642985';
    const PLAN_ID    = '693123023145';
    let   planInput  = productForm.querySelector('input[name="selling_plan"]');

    if (vid === SUB_VID) {
      // If it’s our subscription variant, create or update the plan input
      if (!planInput) {
        planInput = document.createElement('input');
        planInput.type = 'hidden';
        planInput.name = 'selling_plan';
        productForm.appendChild(planInput);
      }
      planInput.value = PLAN_ID;
    } else {
      // Otherwise remove any leftover plan input
      if (planInput) planInput.remove();
    }
  }

  // 4) Run on initial load…
  syncSellingPlan();
  // …and whenever Shopify updates the variant
  variantInput.addEventListener('change', syncSellingPlan);
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["image-slider"] && !window.DesignMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function() {
    const swiper = new Swiper('#hp-hero-slider .hp-swiper-container', {
      wrapperClass: 'hp-swiper-wrapper',
      slideClass: 'hp-swiper-slide',
      allowTouchMove: true,
      spaceBetween: 10,
      slidesPerView: 1,
      lazy: true,
      autoplay: {
        delay: 5000, // Slide display time (5 seconds)
        disableOnInteraction: false
      },
      pagination: {
        el: '.tinyflow-slider__pagination',
        clickable: true,
        renderBullet: function(index, className) {
          return `<button type="button" aria-label="pagination ${
            index + 1
          }" class="tinyflow-slider__pagination__btn ${className}" style="--_progress: 0%;"></button>`;
        }
      },
      on: {
        init: function(swiper) {

// Initial progress bar animation
          setTimeout(() => {
            startProgressBarAnimation(swiper);
          }, 10); // Slight delay to ensure swiper is fully initialized
        },
        slideChange: function(swiper) {

// Restart progress bar animation on slide change
          resetProgressBarAnimation(swiper);
          startProgressBarAnimation(swiper);
        }
      }
    });

    function startProgressBarAnimation(swiper) {
      const activeBullet = swiper.pagination.bullets[swiper.realIndex];
      activeBullet.style.setProperty('--_progress', '100%');
      activeBullet.classList.add('animating');
    }

    function resetProgressBarAnimation(swiper) {
      swiper.pagination.bullets.forEach(function(bullet, index) {
        bullet.style.setProperty('--_progress', '0%');
        bullet.classList.remove('animating');
      });
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["immy-faq-pdp-v2"] && !window.DesignMode) return;
  try {
    
   var items = document.querySelectorAll('.accordion button');

        function toggleAccordion() {
            var itemToggle = this.getAttribute('aria-expanded');

            for (i = 0; i < items.length; i++) {
                items[i].setAttribute('aria-expanded', 'false');
            }

            if (itemToggle == 'false') {
                this.setAttribute('aria-expanded', 'true');
            }
        }

        items.forEach((item) => item.addEventListener('click', toggleAccordion));
        var buttons = document.querySelectorAll('.accordion-item button');

        buttons.forEach(function (button) {
            button.addEventListener('click', function () {
                var upArrows = document.querySelectorAll('.up-arrow');
                var downArrows = document.querySelectorAll('.down-arrow');
                var isExpanded = button.getAttribute('aria-expanded') === 'true';

                upArrows.forEach(function (upArrow) {
                    upArrow.style.display = 'inline';
                });

                downArrows.forEach(function (downArrow) {
                    downArrow.style.display = 'none';
                });

                if (isExpanded) {
                    var upArrow = button.querySelector('.up-arrow');
                    var downArrow = button.querySelector('.down-arrow');
                    upArrow.style.display = 'none';
                    downArrow.style.display = 'inline';
                } else {
                    var upArrow = button.querySelector('.up-arrow');
                    upArrow.style.display = 'inline';
                }
            });
        });
        let FAQItems = document.querySelectorAll('.accordion-item');
        let showMoreButton = document.querySelector('.show-more-button');
        let showLessButton = document.querySelector('.show-less-button');

        // Function to toggle visibility of accordion items
        function toggleAccordionVisibility() {
            for (let i = 5; i < FAQItems.length; i++) {
                FAQItems[i].classList.toggle('hidden-accordion');
            }
        }

        // Initially hide excess accordion items
        toggleAccordionVisibility();

        // Add event listener to "Show More" button
        showMoreButton.addEventListener('click', function () {
            toggleAccordionVisibility();
            showMoreButton.style.display = 'none';
            showLessButton.style.display = 'flex';
        });

        // Add event listener to "Show Less" button
        showLessButton.addEventListener('click', function () {
            toggleAccordionVisibility();
            showLessButton.style.display = 'none';
            showMoreButton.style.display = 'flex';
        });
  

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["immy-faq-section"] && !window.DesignMode) return;
  try {
    
   var items = document.querySelectorAll('.accordion button');

        function toggleAccordion() {
            var itemToggle = this.getAttribute('aria-expanded');

            for (i = 0; i < items.length; i++) {
                items[i].setAttribute('aria-expanded', 'false');
            }

            if (itemToggle == 'false') {
                this.setAttribute('aria-expanded', 'true');
            }
        }

        items.forEach((item) => item.addEventListener('click', toggleAccordion));
        var buttons = document.querySelectorAll('.accordion-item button');

        buttons.forEach(function (button) {
            button.addEventListener('click', function () {
                var upArrows = document.querySelectorAll('.up-arrow');
                var downArrows = document.querySelectorAll('.down-arrow');
                var isExpanded = button.getAttribute('aria-expanded') === 'true';

                upArrows.forEach(function (upArrow) {
                    upArrow.style.display = 'inline';
                });

                downArrows.forEach(function (downArrow) {
                    downArrow.style.display = 'none';
                });

                if (isExpanded) {
                    var upArrow = button.querySelector('.up-arrow');
                    var downArrow = button.querySelector('.down-arrow');
                    upArrow.style.display = 'none';
                    downArrow.style.display = 'inline';
                } else {
                    var upArrow = button.querySelector('.up-arrow');
                    upArrow.style.display = 'inline';
                }
            });
        });
        let FAQItems = document.querySelectorAll('.accordion-item');
        let showMoreButton = document.querySelector('.show-more-button');
        let showLessButton = document.querySelector('.show-less-button');

        // Function to toggle visibility of accordion items
        function toggleAccordionVisibility() {
            for (let i = 5; i < FAQItems.length; i++) {
                FAQItems[i].classList.toggle('hidden-accordion');
            }
        }

        // Initially hide excess accordion items
        toggleAccordionVisibility();

        // Add event listener to "Show More" button
        showMoreButton.addEventListener('click', function () {
            toggleAccordionVisibility();
            showMoreButton.style.display = 'none';
            showLessButton.style.display = 'flex';
        });

        // Add event listener to "Show Less" button
        showLessButton.addEventListener('click', function () {
            toggleAccordionVisibility();
            showLessButton.style.display = 'none';
            showMoreButton.style.display = 'flex';
        });
  

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["immy-golden-capsule-new"] && !window.DesignMode) return;
  try {
    
    // Get all the div elements with class "item-headings" and "text-container"
       var itemHeadings = document.querySelectorAll('.golden-capsule-three-col .item-headings div');
       var textContainers = document.querySelectorAll('.golden-capsule-three-col .text-container div.desc-tab');

       // Add click event listeners to each div in "item-headings"
       itemHeadings.forEach((heading, index) => {
           heading.addEventListener('click', () => {
               console.log(index, textContainers[index]);
               // Remove the "active" class from all divs in "item-headings"
               itemHeadings.forEach(item => item.classList.remove('active'));

               // Remove the "active" class from all divs in "text-container"
               textContainers.forEach(item => item.classList.remove('active'));

               // Add the "active" class to the clicked div in "item-headings"
               heading.classList.add('active');

               // Add the "active" class to the corresponding div in "text-container"
               textContainers[index].classList.add('active');
           });
       });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["immy-golden-capsule"] && !window.DesignMode) return;
  try {
    
  function removeClass() {
    document.querySelectorAll('.item-wrapper ul li').forEach(function (el) {
      el.classList.remove('active');
    });
  }

  // by default
  document.querySelector('.item-wrapper ul li[data-id="3"]').classList.add('active');
  document.querySelector('.tab[data-id="3"]').classList.add('active');

  document.querySelectorAll('.item-wrapper ul li').forEach(function (el) {
    el.addEventListener('click', function (dl) {
      removeClass();
      this.classList.add('active');
      var index = this.getAttribute('data-id');
      var targetTab = document.querySelector('.tab[data-id="' + index + '"]');

      // Check if the targetTab already has the 'active' class
      if (!targetTab.classList.contains('active')) {
        // Remove 'active' class from all siblings
        document.querySelectorAll('.tab').forEach(function (tab) {
          tab.classList.remove('active');
        });

        // Add 'active' class to the clicked element
        targetTab.classList.add('active');
      }
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["immy-progress-section"]) return;
  try {
    
  //          const block = document.querySelectorAll(".block");
  // window.addEventListener("load", function () {
  //   block.forEach((item) => {
  //     let numElement = item.querySelector(".num");
  //     let num = parseFloat(numElement.innerText);
  //     let count = 0;
  //     let time = 2000 / num;
  //     let circle = item.querySelector(".circle");
  //     let interval = setInterval(() => {
  //       if (count >= num) {
  //         clearInterval(interval);
  //       } else {
  //         count += num;
  //         numElement.innerText = count.toFixed(2);
  //       }
  //     }, time);
  //     circle.style.strokeDashoffset = 503 - 5.03 * num;
  //     let dots = item.querySelector(".dots");
  //     dots.style.transform = `rotate(${360 * (num / 100)}deg)`;
  //     if (num == 100) {
  //       dots.style.opacity = 0;
  //     }
  //   });
  // });

  // new code js

  // on scroll fire
  function elementInViewport2(el) {
    var top = el && el.offsetTop;
    var left = el && el.offsetLeft;
    var width = el && el.offsetWidth;
    var height = el && el.offsetHeight;

    while (el.offsetParent) {
      el = el.offsetParent;
      top += el.offsetTop;
      left += el.offsetLeft;
    }

    return (
      top < window.pageYOffset + window.innerHeight &&
      left < window.pageXOffset + window.innerWidth &&
      top + height > window.pageYOffset &&
      left + width > window.pageXOffset
    );
  }

  window.addEventListener('scroll', function () {
    var element = document.querySelector('.progressbar-section');
    if (elementInViewport2(element)) {
      document.querySelector('body').classList.add('added');
    } else {
      document.querySelector('body').classList.remove('added');
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["look-forward-timeline"]) return;
  try {
    
  $(document).ready(function() {
  var slider_wrapper = new Swiper('.look-forward-container', {
    wrapperClass: 'look-forward-wrapper',
    slideClass: 'look-forward-slide',
    allowTouchMove: true,
    speed: 700,
    spaceBetween: 0, // No space between slides
    slidesPerView: 1,
    centeredSlides: true,
    scrollbar: {
      el: '.swiper-scrollbar',
      draggable: true
    },
    on: {
      init: function() {
        this.update();
      },
      resize: function() {
        this.update();
      }
    }
  });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product-v2-main"] && !window.DesignMode) return;
  try {
    
document.addEventListener('DOMContentLoaded', function () {
  const swiper = new Swiper('.pg-swiper-container', {
    wrapperClass: 'pg-swiper-wrapper',
    slideClass: 'pg-swiper-slide',
    allowTouchMove: true,
    spaceBetween: 10,
    slidesPerView: 1,
    lazy: true,
    autoplay: {
      delay: 5000,
      disableOnInteraction: false,
    },
    keyboard: {
      enabled: true,
      onlyInViewport: true,
    },
    pagination: {
      el: '.tinyflow-slider__pagination',
      clickable: true,
      renderBullet: function (index, className) {
        return `<button type="button" aria-label="pagination ${index + 1}" class="tinyflow-slider__pagination__btn ${className}" style="--_progress: 0%;"></button>`;
      },
    },
    on: {
      init: function (swiper) {
        setTimeout(() => {
          startProgressBarAnimation(swiper);
        }, 10);
      },
      slideChange: function (swiper) {
        resetProgressBarAnimation(swiper);
        startProgressBarAnimation(swiper);
      },
    },
  });

  function startProgressBarAnimation(swiper) {
    const activeBullet = swiper.pagination.bullets[swiper.activeIndex];
    activeBullet.style.setProperty('--_progress', '100%');
    activeBullet.classList.add('animating');
  }

  function resetProgressBarAnimation(swiper) {
    swiper.pagination.bullets.forEach(function (bullet) {
      bullet.style.setProperty('--_progress', '0%');
      bullet.classList.remove('animating');
    });
  }
});


//WHY SUBSCRIBE POPUP
  document.getElementById('why-sub').addEventListener('click', function(event) {
    event.preventDefault(); // Prevent the default link behavior
    document.getElementById('sub-popup').classList.add('active'); // Show the popup
    document.getElementById('popup-overlay').classList.add('active'); // Show the overlay
  });

  document.getElementById('popup-overlay').addEventListener('click', function() {
    document.getElementById('sub-popup').classList.remove('active'); // Hide the popup
    document.getElementById('popup-overlay').classList.remove('active'); // Hide the overlay
  });

  document.getElementById('close-popup').addEventListener('click', function() {
    document.getElementById('sub-popup').classList.remove('active'); // Hide the popup
    document.getElementById('popup-overlay').classList.remove('active'); // Hide the overlay
  });


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["reviews-slider"] && !window.DesignMode) return;
  try {
    
document.addEventListener('DOMContentLoaded', function () {
  const swiper = new Swiper("#How-immy-works-slider .swiper-container", {
    wrapperClass: "swiper-wrapper",
    slideClass: "swiper-slide",
    allowTouchMove: true,
    spaceBetween: 10,
    lazy: true,
    autoplay: {
      delay: 5000,
      disableOnInteraction: false,
    },
    keyboard: {
      enabled: true,
      onlyInViewport: true,
    },
    pagination: {
      el: ".tinyflow-slider__pagination",
      type: "custom",
      clickable: true,
      renderCustom(swiper, current, total) {
        // compute prev / current / next (1-based)
        const prev = current === 1 ? total : current - 1;
        const next = current === total ? 1 : current + 1;
        // on initial load (current===1), make the first bullet active; otherwise center bullet
        const activeIdx = current === 1 ? 0 : 1;
        const slides = [prev, current, next];
        return slides
          .map((slideNum, idx) => `
            <button
              type="button"
              class="tinyflow-slider__pagination__btn${idx === activeIdx ? ' swiper-pagination-bullet-active' : ''}"
              data-slide="${slideNum}"
              aria-label="Go to slide ${slideNum}"
              style="--_progress:0%;"
            ></button>
          `)
          .join('');
      }
    },
    breakpoints: {
      0:   { centeredSlides: false },
      668: { slidesPerView: 1 },
      992: { slidesPerView: 2 },
      1300:{ slidesPerView: 3 }
    },
    on: {
      init(swiper) {
        resetProgress(swiper);
        startProgress(swiper);
      },
      slideChange(swiper) {
        resetProgress(swiper);
        startProgress(swiper);
      }
    }
  });

  // clicking bullets jumps to that slide
  document.querySelector('.tinyflow-slider__pagination')
    .addEventListener('click', e => {
      const btn = e.target.closest('.tinyflow-slider__pagination__btn');
      if (!btn) return;
      const idx = parseInt(btn.dataset.slide, 10) - 1;
      swiper.slideToLoop(idx);
    });

  function startProgress(swiper) {
    const bullet = document.querySelector('.tinyflow-slider__pagination__btn.swiper-pagination-bullet-active');
    if (!bullet) return;
    bullet.classList.remove('animating');
    void bullet.offsetWidth; // force reflow
    bullet.classList.add('animating');
    bullet.style.setProperty('--_progress', '100%');
  }

  function resetProgress(swiper) {
    document.querySelectorAll('.tinyflow-slider__pagination__btn').forEach(b => {
      b.classList.remove('animating');
      b.style.setProperty('--_progress', '0%');
    });
  }
});

  } catch(e) { console.error(e); }
})();
})();
